import React, { useEffect, useState } from "react";
import RemedyAddEdit from "./RemedyAddEdit";
import { EditRemedies, RemediesDetails } from "../../services/remedise.services";
import { useParams } from "react-router-dom";
import { Avatar, Loader } from "rsuite";

const EditRemedy = () => {
    const params = useParams();
    const [initialValues, setInitialValues] = useState({});
    const [loader, setLoader] = useState(false);

    console.log("Remedy ID:", params.id);

    useEffect(() => {
        setLoader(true);
        RemediesDetails(params?.id)
            .then((response) => {
                setInitialValues(response && response.data ? response.data : {});
                setLoader(false);
            })
            .catch((error) => {
                console.error("Error fetching remedy details:", error);
                setLoader(false);
            });
    }, [params.id]);

    console.log("Initial Values:", initialValues);

    return (
        <div>
            {loader ? (
                <Loader />
            ) : (
                <RemedyAddEdit
                    initialValues={{
                        o_id: params.id || "",
                        remedy_type: initialValues?.remedy_type || "",
                        name: initialValues?.name || "",
                        price: initialValues?.price || "",
                        discount: initialValues?.discount || "",
                        rating: initialValues?.rating || "",
                        average_rating: initialValues?.average_rating || "",
                        stock: initialValues?.stock || "",
                        refundable: initialValues?.refundable || false,
                        description: initialValues?.description || "",
                        image: initialValues?.image || "",
                        attributes: initialValues?.attributes || {},
                    }}
                    onSubmit={EditRemedies}
                    isEdit={true}
                />
            )}
        </div>
    );
};

export default EditRemedy;
